import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { AccountService } from '../../../services';
import { ResetAccountModel } from '../../../models/account';
import { AppUtils } from '../../../helpers';

declare var activateFormLineControlPlaceholder: any;

@Component({
    selector: 'reset-account',
    templateUrl: './account.reset.component.html'
})

export class AccountResetComponent implements OnInit {
    @BlockUI('frm-reset') blockUI: NgBlockUI;

    model: ResetAccountModel = new ResetAccountModel();

    constructor(private vcr: ViewContainerRef,
        private route: ActivatedRoute,
        private router: Router,
        private toastr: ToastsManager,
        private appUtils: AppUtils,
        private accountService: AccountService) {
        this.toastr.setRootViewContainerRef(this.vcr);
        this.route.queryParams.subscribe(params => {
            this.model.key = params['key'];
            this.model.secret = params['secret'];
        });
    }

    ngOnInit() {
        activateFormLineControlPlaceholder();
    }

    submit() {
        this.blockUI.start();
        this.accountService.resetAccount(this.model)
            .subscribe(
                () => {
                    this.blockUI.stop();
                    this.router.navigate(['/account/login']);
                    setTimeout(() => {
                        this.toastr.success('Your password has been reset succssfully. Please login to continue.');
                    }, 100);
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }
}



// WEBPACK FOOTER //
// ./src/components/account/reset/account.reset.component.ts